import {TextEncoder} from "encoding";
import Bottleneck from "bottleneck";
import sleep from "sleep";
import * as usbutil from "../usbutil.js";
import Device from "../device.js";


const TIMEOUT = 500;

const RESPONSE_CODE = {
  "ER": "unknown command",
  "OV": "over volt (VCC>=5.5V)",
  "UV": "under volt (VCC<=3.1V)",
  "RS": "reset",
  "RE": "boot up complete, ready",
  "SL": "entering sleep mode",
  "WA": "wake up",
  "DONE": "dispensing complete",
  "MINVOL": "dispense amount too low",
  "TOOFAST": "ml/min set to fast"
};


class MyDevice extends Device {
  constructor(serialPort) {   
    super();
    
    this.serialPort = serialPort;
  }
  async initialize() {
    try {    
      this.id = "uninitialized";
      this.status = "uninitialized";            
      this.usbProductName = (await this.serialPort.getInfo()).usbProductName;
	  this.usbSerialNumber = (await this.serialPort.getInfo()).usbSerialNumber;    
      this.name = usbutil.getDeviceName(`${this.usbProductName}_${this.usbSerialNumber}`) || "ezoPump";

      this.limiter = new Bottleneck({
        maxConcurrent: 1,
        minTime: 10
      });    

      /* publicate remote methods to clients */
      let endpoint = `${this.usbProductName}_${this.usbSerialNumber}`;
      jfermi[`RM_${endpoint}_clearTotalDispensedVolume`] = this.RM_ezopump_clearTotalDispensedVolume.bind(this);
      jfermi[`RM_${endpoint}_setMLH`] = this.RM_ezopump_setMLH.bind(this);
      jfermi[`RM_${endpoint}_blink`] = this.RM_ezopump_blink.bind(this);    
      jfermi[`RM_${endpoint}_dose`] = this.RM_ezopump_dose.bind(this);    
      jfermi[`RM_${endpoint}_calibrate`] = this.RM_ezopump_calibrate.bind(this);    
      jfermi[`RM_${endpoint}_clearCalibration`] = this.RM_ezopump_clearCalibration.bind(this);    

      await this.serialPort.open({
        baudRate: 9600,
        dataBits: 8,
        parity: "none",
        stopBits: 1    
      });      
      this.status = "OK";

      /* enable response codes */
      await this.command("*OK,1");

      /* disable continuous reporting mode */      
      await this.command("C,0");

      /* Wait for the device to boot up completly */
      while(1) {
        try {
          this.id = await this.command("i");
          this.id = await this.command("i");
          break;
        } catch(e) {
          if (e.message == "reset" || e.message == "boot up complete, ready")
            console.log("EZO PMP bootup...");
          else
            throw e;
        }
      }

      /* disable internal temperature from output string */
      if (await this.command("O,?") != "?O,V") {
        await this.command("O,V,1"); //enable volume being pumped in output string
        await this.command("O,TV,0"); //disable total volume pumped in output string
        await this.command("O,ATV,0"); //disable absolute volume pumped in output string
      }

      this.__interval = setInterval(this.__dose.bind(this), 1000);

      this.__ml = 0;
      this.mlh = 0;
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async disconnect() {
    clearInterval(this.__interval);
  }
  async update() {

    try {          
      //this.mlh = parseFloat(await this.command("R"));
      this.sumML = parseFloat((await this.command("TV,?")).replace("?TV,", ""));

      this.calibrationStatus = {
        "?CAL,0": "uncalibrated",
        "?CAL,1": "fixed volume",
        "?CAL,2": "volume/time",
        "?CAL,3": "both fixed valume and volume/time"
      }[await this.command("Cal,?")];

      this.voltage = await this.getVoltage();

      this.status = "Ok";
    } catch(e) {
      this.status = "Failed";
      throw e;
    }      
  }
  /* sending new command to the device while waiting for the response may cause concurrency problems           */
  /* so we wrapped the function and limited the maximum number of concurrent calls to 1 with bottlenck library */  
  async command(command) {
    return await this.limiter.schedule(() => this.command_wrapped(command));
  }
  async command_wrapped_again(command) {    
    let result;
    while(1) {
      try {
        result = await this.command_wrapped(command);
        return result;
      } catch(e) {
        if (command.startsWith("D") && e.message == "dispensing complete")
          return result;
        else if (e.message == "dispensing complete")
          console.log("Again");
        else
          throw e;
      }
    }

  }
  async command_wrapped(command) {      
    var reader;
    var timeout;

    //console.log(`command: ${command}`);

    var promiseCommand = new Promise(async function _(resolve, reject) {      
      const encoder = new TextEncoder();
      const writer = this.serialPort.writable.getWriter();    
      await writer.write(encoder.encode(`${command}\r`).buffer);
      writer.releaseLock();          

      if (command == "*OK,1") {
        resolve("");
        return;
      }

      if (command == "C,0") {
        resolve("");
        return;
      }

      /* we sent the command to the sensors/controller
     * now we start waiting for the reponse
     * here is some command and the responses
     *  DC,5,* --> *OK\r
     *  --> TOOFAST\r*ER\r
     *  X --> *DONE,10\r*OK\r
     *  Cal,? --> ?TV,7.93\r
     *  Cal,? --> ?TV,7.93 Note: sometimes we dont receive \r character -> throw timeout
     *
     * We handle these two commands as an exception, we dont wait any resonse for these commands
     * *OK,1 --> no response      
     * C,0 --> *Done,3.00
     *
     * When we power on the device we sometimes receive:*RS\r*RE\r
     */

      var result = "";
      var response_code;

      reader = this.serialPort.readable.getReader();

      try {
        while (true) {
          const { value, done } = await reader.read();
          //console.log(`chunk: ${new Uint8Array(value)}`);

          result += String.fromCharCode.apply(null, new Uint8Array(value));

          // DONE response cannot be disabled, problem: I receive DONE response for another request
          // when we receive DONE response string we simply ignore that
          //console.log(`DONE: ${result.match(/.*\*DONE.*\r/g)}`);
          result = result.replace(/.*\*DONE.*\r/g, "");

          //console.log(`chunk: ${new Uint8Array(value)}`);          
          if (done || result.match(/.*\*.*\r$/g)) {    

            //console.log(`result match: ${result.replace("\r","\n").replace("\r","\n")}`);

            //response_code = /(?<=\*)(.*?)(?=\r)/g.exec(result)[0];
            response_code = /(?<=\*)(.*?)(?=(\r|,))/g.exec(result)[0];            
            response_code = response_code.replace(/(\r\n|\n|\r)/gm, "");
            response_code = response_code.toUpperCase();

            // |reader| has been canceled.       
            result = result.replace("*OK\r","");
            result = result.replace("*DONE,","");
            result = result.replace("\r","");
            result = result.toUpperCase();     
            break;
          }        
        } //while
      } catch(e) {        
        if (e instanceof TypeError)
          /* TIMEOUT */;
        else
          throw e;        
      }
      //console.log(`code: ${response_code}, result: ${result}`);

      reader.releaseLock();

      if (response_code == "OK") {        
        resolve(result);
      } else {        
        reject( new Error(RESPONSE_CODE[response_code]) );                
      }

    }.bind(this));

    var promiseTimeout = new Promise(function(resolve, reject) {
      setTimeout(function() {   
        if (reader)
          reader.releaseLock();
        reject(new Error("Timeout"));
      }, TIMEOUT);
    }.bind(this));       


    return await Promise.race([promiseCommand, promiseTimeout]);    
  }
  async clearTotalDispensedVolume() {
    try {
      await await this.command("Clear");
    } catch(e) {
      console.error(e.message);
      throw e;
    }           
  }
  async setMLH(mlh) {    
    this.mlh = mlh;
  }  
  async __dose() {        
    this.__ml += this.mlh/(60*60);
    //console.log(this.__ml);

    if (this.__ml >= 0.5) {            
      let ml = Math.round(this.__ml/0.5);      
      await this.command(`D,${ml*0.5}`);
      this.__ml -= ml*0.5;      
    }
  }
  async getVoltage() {
    return parseInt( (await this.command("PV,?")).replace("?PV,", "") );
  }
  async blink() {    
    try {
      await this.command("Find");
    } catch(e) {
      console.error(e.message);
      throw e;
    }        
  }
  async RM_ezopump_clearTotalDispensedVolume() {    
    try {
      await this.clearTotalDispensedVolume();
    } catch(e) {
      console.error(e.message);
      throw e;
    }        
  }
  async RM_ezopump_clearCalibration() {    
    try {
      await this.command("Cal,clear");
    } catch(e) {
      console.error(e.message);
      throw e;
    }        
  }  
  async RM_ezopump_calibrate(event, ml) {    
    try {
      console.log(`Cal,${ml}`);
      await this.command(`Cal,${ml}`);
    } catch(e) {
      console.error(e.message);
      throw e;
    }        
  }    
  async RM_ezopump_setMLH(request, mlh) {    
    try {
      await this.setMLH(mlh);
      console.log(`${request.client.username}: ${this.name} set to ${mlh} mlh`);
    } catch(e) {
      console.error(e.message);
      throw e;
    }        
  }  
  async RM_ezopump_blink() {        
    try {
      await this.blink();  
    } catch(e) {
      console.error(e.message);
      throw e;
    }    
  }    
  async RM_ezopump_dose(request, ml) {
    try {
      await this.command(`D,${ml}`);
    } catch(e) {
      console.error(e.message);
      throw e;
    }
  }      
  logData(logData) {
    logData.append(`${this.name}_mlh`, this.mlh);
    logData.append(`${this.name}_ml`, this.sumML);
  }
  toJSON() {
    return({
      name: this.name,      
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status,      
      id: this.id,
      voltage: this.voltage,
      rpm: this.rpm,
      mlh: this.mlh,
      calibrationStatus: this.calibrationStatus,
      sumML: this.sumML
    });
  }
}

export default MyDevice;